import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)
const state = {
    // 用户信息
    userData: {
        name: "",
        permissions: [],
        userId: "",
        userName: ""
    },
    // 对话框信息
    confirmModalOption: {
        // 对话框显示状态
        modalVisiabal: false,
        // 对话框标题
        title: '',
        // 对话框内容
        content: '',
        // 样式名
        className: "",
        HandleOk: () => {}
    },
    // 首页不显示返回首页按钮
    backShow: true,
    // 表格高度
    tableHeight: null
}
const getters = {
    // 外部获取用户信息
    getUserData(state) {
        return state.userData
    },
    // 外部获取确认对话框参数
    getModalOption(state) {
        return state.confirmModalOption
    }
}
const mutations = {
    updateUserData(state, obj) {
        state.userData = obj
    },
    updateModalOption(state, obj) {
        let { modalVisiabal, title, content, className, HandleOk } = obj
        if (modalVisiabal !== undefined) {
            state.confirmModalOption.modalVisiabal = modalVisiabal
        }
        if (title) {
            state.confirmModalOption.title = title
        }
        if (content) {
            state.confirmModalOption.content = content
        }
        if (className) {
            state.confirmModalOption.className = className
        }
        if (HandleOk) {
            state.confirmModalOption.HandleOk = HandleOk
        }
    },
    updateBackStatus(state, is) {
        state.backShow = is
    },
    // 获取表格高度
    updateTableHeight(state) {
        state.tableHeight = document.documentElement.clientHeight - 340
    }
}
const actions = {}
const modules = {};
export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    modules,
    // 添加插件在F5刷新前将数据存储入sessionStorage中，刷新后将数据恢复
    plugins: [
        createPersistedState({
            storage: window.sessionStorage
        })
    ],
    modules: {}
});